import React, { useEffect, useState } from "react";

const PowerAppSolutions = ({ solution }) => {
  const [appUrl, setAppUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchAppUrl = async (name) => {
    try {
      setIsLoading(true);
      const res = await fetch(`/api/app-url?name=${name}`);
      const data = await res.json();
      setAppUrl(data.url);
    } catch (err) {
      console.error("Error fetching app URL:", err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAppUrl(solution);
  }, [solution]);

  return (
    <div className="flex w-full flex-col overflow-hidden" style={{ height: "calc(100vh - 50px)" }}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600"></div>
        </div>
      )}

      {/* IFRAME */}
      {appUrl && (
        <iframe
          src={appUrl}
          title={solution}
          className="w-full flex-1 border-none"
          allow="geolocation; microphone; camera"
          allowFullScreen
          onLoad={() => setIsLoading(false)}
        />
      )}
    </div>
  );
};

export default PowerAppSolutions;
